import React from 'react'
import { useRef, useState } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { TextWrap } from "../../util/showmore";
import { getCallConferenceAgent, getCallSessionAgent } from "./api";
import { CallControls } from "./CallControls";
import { CallMenuList } from "./CallMenuList";
import * as constants from "./constants";
import { GetCallProgess } from "./GetCallProgress";
import { getAgentPhone, GetAgentPhotoOrInitial, getName } from "./helpers";
import { actionTypes } from "./reducer";
import { Timer } from "./Timer";

export function ConferenceCall(props) {
  const { callFlow } = props;
  const dispatch = useDispatch();
  const sessionAgent = getCallSessionAgent();
  const legCAgent = getCallConferenceAgent();

  const window_state = useSelector((state) => {
    return state.ticker.window_state;
  });
  const handleMinimize = () => {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: { window_state: constants.C2C_CONSTANTS.WINDOW_STATE_MINIMIZED },
    });
  };

  const handleMaximize = () => {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: { window_state: constants.C2C_CONSTANTS.WINDOW_STATE_OPENED },
    });
  };
  function ClipWithTip(props) {
    const [show, _setShow] = useState(false);
    const target = useRef(null);

    const setShow = (v) => {
      _setShow(v);
      if (v) {
        setTimeout(() => {
          _setShow(false);
        }, 1000);
      }
    };

    return (
      <>
        <CopyToClipboard
          text={props.text}
          onCopy={() => {
            setShow(true);
          }}
        >
          <img
            alt=""
            ref={target}
            onClick={() => setShow(!show)}
            className="copy-icn"
            draggable="false"
            style={{ cursor: 'pointer' }}
            src={toAbsoluteUrl("/media/sr/icons/crm/copy.svg")}
          />
        </CopyToClipboard>
        <Overlay target={target.current} show={show} placement="right">
          {(props) => (
            <Tooltip id="overlay-example" {...props}>
              Copied to clipboard.
            </Tooltip>
          )}
        </Overlay>
      </>
    );
  }

  return (
    <>
      <div className="tmodal tmodal-dialog-scrollable call-ticker-dialog-sec">
        <div className="tmodal-content">
          {/**<LiveCallMinimized {...props} />**/}

          <div className="tmodal-body list-agentsdd">
            {window_state == constants.C2C_CONSTANTS.WINDOW_STATE_MINIMIZED ? (
              <div className="d-flex justify-content-between align-items-center live-call-header minimize">
                <div className="header-content">
                  <div className="number-sec">
                    <div className="head-sec-title">SR Number:</div>
                    <div className="head-sec-detail">
                      {props.callFlow.getSRNumber()}
                    </div>
                  </div>
                  <div className="quick-detail-sec">
                    <span className="voice-indicator">
                      <img
                        alt=""
                        src={toAbsoluteUrl(
                          "/media/sr/icons/voice-indicator.svg"
                        )}
                      />
                    </span>
                    <span className="call-timer-min">
                      <Timer disableSymbols={true} />
                    </span>
                  </div>
                  {props.callFlow.hasQueue() && props.callFlow.getQueueName() && (
                    <div class="queue-sec">
                      <div className="head-sec-title">Queue:</div>
                      <div className="head-sec-detail">
                        <TextWrap
                          text={props.callFlow.getQueueName()}
                          max={props.isMobile ? 10 : 12}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="click-icon">
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleMaximize();
                    }}
                  >
                    <img
                      alt=""
                      className="header-close-icon"
                      src={toAbsoluteUrl("/media/sr/icons/ticker-maximize.svg")}
                    />
                  </a>
                </div>
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-center  live-call-header">
                  <div className="header-content">
                    <div className="number-sec">
                      <div className="head-sec-title">SR Number:</div>
                      <div className="head-sec-detail">
                        {props.callFlow.getSRNumber()}
                      </div>
                    </div>
                    {props.callFlow.hasQueue() &&
                      props.callFlow.getQueueName() && (
                        <div class="queue-sec">
                          <div className="head-sec-title">Queue:</div>
                          <div className="head-sec-detail">
                            <TextWrap
                              text={props.callFlow.getQueueName()}
                              max={props.isMobile ? 10 : 12}
                            />
                          </div>
                        </div>
                      )}
                  </div>
                  <div className="click-icon" onClick={handleMinimize}>
                    <img
                      alt=""
                      className="header-close-icon"
                      src={toAbsoluteUrl("/media/sr/icons/ticker-minimize.svg")}
                    />
                  </div>
                </div>
                <div className="py-7 px-5">
                  <div className="live-call-section">
                    <div className="mt-7 row justify-content-center ">
                      <div className="cc-title">Conference Call</div>
                    </div>
                    <div className="row justify-content-center ">
                      <div className="cc-duration">
                        <span>
                          <GetCallProgess />:{" "}
                        </span>
                        <span>
                          <Timer disableSymbols={true} />
                        </span>
                      </div>
                    </div>
                    <div className="row justify-content-center ">
                      <div className="column-ct-flex">
                        <GetAgentPhotoOrInitial
                          agent={{
                            first_name: callFlow.getCustomerName(),
                            last_name: null,
                          }}
                          wrapCls="usr-photo user-status"
                          imgCls="usr-photo-icon status-available"
                        />

                        <div className="usr-name">
                          <TextWrap
                            text={props.callFlow.getCustomerName()}
                            max={17}
                          />
                          {callFlow.state.callInitialEvent &&
                            callFlow.state.callInitialEvent
                              .variable_sticky_agent === "1" && (
                              <span className="ml-1">
                                <img
                                  alt=""
                                  style={{
                                    verticalAlign: "top",
                                    borderStyle: "none",
                                    height: "22px",
                                    marginTop: "-4px",
                                  }}
                                  className="sticky-ag "
                                  src={toAbsoluteUrl(
                                    "/media/sr/icons/sticky-agent.svg"
                                  )}
                                />
                              </span>
                            )}
                        </div>
                        <div className="usr-number">
                          <TextWrap
                            text={props.callFlow.getCustomerNumber()}
                            max={17}
                          />
                          <div>
                            <ClipWithTip
                              text={props.callFlow.getCustomerNumber()}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="cc-connection ml-5 mr-5">
                      <div className="c-usr-one">
                        <div className="column-ct-flex">
                          <GetAgentPhotoOrInitial
                            agent={sessionAgent}
                            wrapCls="usr-photo user-status"
                            imgCls="usr-photo-icon status-available"
                          />

                          <div
                            className="usr-name"
                            style={{ cursor: "pointer" }}
                          >
                            <TextWrap
                              text={getName(sessionAgent)}
                              max={props.isMobile ? 14 : 14}
                            />
                          </div>
                          <div
                            className="usr-number"
                            style={{ cursor: "pointer" }}
                          >
                            <TextWrap
                              text={getAgentPhone(sessionAgent)}
                              max={14}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="bw-voice-indicator">
                        <img
                          alt=""
                          className="usr-photo-icon"
                          src={toAbsoluteUrl(
                            "/media/sr/icons/voice-indicator-green.svg"
                          )}
                        />
                      </div>
                      <div className="c-user-two">
                        <div className="column-ct-flex">
                          <GetAgentPhotoOrInitial
                            agent={legCAgent}
                            wrapCls="usr-photo user-status"
                            imgCls="usr-photo-icon status-available"
                          />

                          <div
                            className="usr-name"
                            style={{ cursor: "pointer" }}
                          >
                            <TextWrap
                              text={getName(legCAgent)}
                              max={props.isMobile ? 14 : 14}
                            />
                          </div>
                          <div
                            className="usr-number"
                            style={{ cursor: "pointer" }}
                          >
                            <TextWrap
                              text={getAgentPhone(legCAgent)}
                              max={14}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="call-detail-sec cc-call">
                      <CallControls callFlow={callFlow} />
                    </div>
                    <CallMenuList {...props} tc_disabled={true} />
                  </div>
                </div>
              </>
            )}
          </div>

          {/* <Modal.Header className="live-call-header minimize">
            <div className="header-content">
            <div className="number-sec">
                <div className="head-sec-title">
                SR Number:
                </div>
                <div className="head-sec-detail">
                +42 6353637372
                </div>
            </div>
            <div className="quick-detail-sec">
                <span className="voice-indicator">
                    <img src={toAbsoluteUrl("/media/sr/icons/voice-indicator.svg")} />
                </span>
                <span className="call-timer-min">
                02M : 10S
                </span>
            </div>
            <div class="queue-sec">
                <div className="head-sec-title">
                Queue: 
                </div>
                <div className="head-sec-detail">
                Sales Group
                </div>
            </div>
            </div>
            <div className="click-icon" onClick={handleClose}>
                <img className="header-close-icon" src={toAbsoluteUrl("/media/sr/icons/ticker-maximize.svg")} />
            </div>
        </Modal.Header> */}
        </div>
      </div>
    </>
  );
}
